<template>
  <!-- <div class="modal-wrapper"> -->
    <b-modal title="Add Product" no-close-on-esc no-close-on-backdrop size="lg" hide-footer class="modal-info" v-model="largeModal" @ok="largeModal = false">
   <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Name<span style="color:red"> *</span></label>
                   <!--<input type="text" class="form-control" autocomplete="off" id="productname" :class="{'is-invalid':hasErrors.productname}" @blur.native="chkProductExist()"  name="productname" v-model="product.productname"  placeholder="Enter Product Name">-->
                   <input type="text" class="form-control" autocomplete="off" id="productname" :class="{'is-invalid':hasErrors.productname}" name="productname" v-model="product.productname"  placeholder="Enter Product Name">
                    <small  class="form-text text-muted" v-if="hasErrors.productname" ><strong style="color: red;"> {{errorMessage.productname}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Category</label>
                    <model-list-select :list="category" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="category_name" option-text="category_name" v-model="selectedCategory" placeholder="Select Category" @input="subcategory1"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Sub Category</label>
                    <model-list-select :list="subcategory" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="sub_category_name" option-text="sub_category_name" v-model="selectedSub" placeholder="Select Sub Category"></model-list-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Brand</label>
                    <model-list-select :list="brndopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="brand_name" option-text="brand_name" v-model="selectedBrand" placeholder="Select Brand"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <!-- <label for="name">HSN Code <span style="color:red"> *</span></label> -->
                    <label for="name">{{ companyTaxType === 'US' ? 'US Code' : 'HSN Code' }} </label>
                    <model-list-select :list="hsnopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="hsn_id" option-text="hsn_code" v-model="selectedHsn" placeholder="Select Hsn" @input="tax_name"></model-list-select>
                     <small  class="form-text text-muted" v-if="errorMessage.selectedHsn" ><strong style="color: red;"> {{errorMessage.selectedHsn}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <!-- <label for="name">Tax <span style="color:red"> *</span></label> -->
                    <label for="name">Tax </label>
                    <model-list-select readonly :list="taxopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="tax_name" option-text="tax_name" v-model="selectedTax" placeholder="Select Tax"></model-list-select>
                    <small  class="form-text text-muted" v-if="errorMessage.selectedTax" ><strong style="color: red;"> {{errorMessage.selectedTax}}</strong></small>
                  </div>
                </div>
              </div>
              
              <div class="row">

                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Unit</label>
                    <model-list-select :list="unitopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="unit_name" option-text="unit_name" v-model="selectedUnit" placeholder="Select Unit"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4" >
                  <div class="form-group" >
                    <label for="name">SKU</label>
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.altproductid}" autocomplete="off"  v-model="product.altproductid" placeholder="Enter SKU">
                    <small class="form-text text-muted" v-if="hasErrors.altproductid" ><strong style="color: red;">Enter Valid Product Id</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Variant</label>
                    <model-list-select class="form-control" :list="varientlist" option-value="variant_id" option-text="variant_name" v-model="product.variantname" placeholder="Select Variant" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                    <small  class="form-text text-muted" v-if="hasErrors.variantname" ><strong style="color: red;">Enter Valid Variant Name</strong></small>
                  </div> 
                </div>
              </div>
 
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Product Description</label>
                    <vue-editor id="productdesc" name="productdesc" :class="{'is-invalid':hasErrors.productdesc}" v-model="product.productdesc" ></vue-editor>
                    <small  class="form-text text-muted" v-if="hasErrors.productdesc" ><strong style="color: red;">Enter Valid Product Description</strong></small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 1 :</label>
                    <b-form-file name="product.image1" :state="Boolean(errorMessage.image1==null)" accept="image/*" id="image1" placeholder="Choose a file..."  ref="fileinput1"></b-form-file>
                    <p v-if="product.imageArr[0]">View Image <a :href="product.imageUrl[0]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image1" ><strong style="color: red;">{{errorMessage.image1}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 2 :</label>
                    <b-form-file name="product.image2" :state="Boolean(errorMessage.image2==null)" accept="image/*" id="image2" placeholder="Choose a file..."  ref="fileinput2"></b-form-file>
                    <p v-if="product.imageArr[1]">View Image <a :href="product.imageUrl[1]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image2" ><strong style="color: red;">{{errorMessage.image2}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 3 :</label>
                    <b-form-file name="product.image3" :state="Boolean(errorMessage.image3==null)" accept="image/*" id="image3" placeholder="Choose a file..."  ref="fileinput3"></b-form-file>
                    <p v-if="product.imageArr[2]">View Image <a :href="product.imageUrl[2]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image3" ><strong style="color: red;">{{errorMessage.image3}}</strong></small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 4 :</label>
                    <b-form-file name="product.image4" :state="Boolean(errorMessage.image4==null)" accept="image/*" id="image4" placeholder="Choose a file..."  ref="fileinput4"></b-form-file>
                    <p v-if="product.imageArr[3]">View Image <a :href="product.imageUrl[3]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image4" ><strong style="color: red;">{{errorMessage.image4}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 5 :</label>
                    <b-form-file name="product.image5" :state="Boolean(errorMessage.image5==null)" accept="image/*" id="image5" placeholder="Choose a file..."  ref="fileinput5"></b-form-file>
                    <p v-if="product.imageArr[4]">View Image <a :href="product.imageUrl[4]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image5" ><strong style="color: red;">{{errorMessage.image5}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 6 :</label>
                    <b-form-file name="product.image6" :state="Boolean(errorMessage.image6==null)" accept="image/*" id="image6" placeholder="Choose a file..."  ref="fileinput6"></b-form-file>
                    <p v-if="product.imageArr[5]">View Image <a :href="product.imageUrl[5]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image6" ><strong style="color: red;">{{errorMessage.image6}}</strong></small>
                  </div>
                </div>
              </div>

              <hr>
              
              <div class="row">
                <div class="col-sm-4">
                  <label for="name">Product Specification :</label>
                </div>
                <div class="col-sm-6">
                  <label for="name">Product Specification Description</label> 
                </div>
                <div class="col-sm-2"></div>
              </div>

              <div class="row" v-for="(spec, index) in specs">
                <div class="col-sm-4">
                  <div class="form-group">
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.specname}" autocomplete="off" v-model="spec.specname" placeholder="Enter Product Specification">
                    <small  class="form-text text-muted" v-if="hasErrors.specname" ><strong style="color: red;">Enter Valid Specification  Name</strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                   <div class="form-group">
                      <input type="text" class="form-control" :class="{'is-invalid':hasErrors.specdesc}" autocomplete="off" v-model="spec.specdesc" placeholder="Enter Product Specification Description">
                      <small  class="form-text text-muted" v-if="hasErrors.specdesc" ><strong style="color: red;">Enter Valid Specification Description</strong></small>
                   </div>
                </div>
                <div class="col-sm-2" style="margin-top: 3px;">
                  <div class="form-group">
                   <button @click="addRow" class="btn btn-primary btn-sm"><i class="fa fa-plus"></i></button>
                   <button v-on:click="removeElement(index);" v-if="(index != 0)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></button>
                  </div>
                </div>
              </div>
              

              <hr>

              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                  <label for="name">Custom Field 1</label> 
                  <input type="text" class="form-control" id="productcf1" :class="{'is-invalid':hasErrors.productcf1}" autocomplete="off" v-model="product.productcf1" name="productcf1" placeholder="Custom Field Label 1">
                  <small  class="form-text text-muted" v-if="hasErrors.productcf1" ><strong style="color: red;">Enter Valid Product Classification</strong></small>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                  <label for="name">Custom Field 2</label> 
                  <input type="text" class="form-control" autocomplete="off"  v-model="product.productcf2" placeholder="Custom Field Label 2">
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                  <label for="name">Custom Field 3</label> 
                  <input type="text" class="form-control"  v-model="product.productcf3" placeholder="Custom Field Label 3">
                  </div>
                </div>
                 <div class="col-sm-3">
                  <div class="form-group">
                    <b-form-checkbox id="checkbox1" v-model="checkboxqty" value="true" unchecked-value="false">Alert Quantity</b-form-checkbox>
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.productalert}" v-model="product.productalertqty" placeholder="Enter Alert Quantity">
                    <small class="form-text text-muted" v-if="hasErrors.productalert" ><strong style="color: red;">Enter Valid Product Alert Quantity</strong></small>
                  </div>
                </div> 
                </div>

              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                      
                  <input type="text" class="form-control" id="productcf_val1" :class="{'is-invalid':hasErrors.productcf_val1}" autocomplete="off" v-model="product.productcf_val1" name="productcf_val1" placeholder="Custom Field value 1">
                  <small  class="form-text text-muted" v-if="hasErrors.productcf_val1" ><strong style="color: red;">Enter Valid Product Classification</strong></small>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                
                  <input type="text" class="form-control" id="productcf_val2" :class="{'is-invalid':hasErrors.productcf_val2}" autocomplete="off"  v-model="product.productcf_val2" placeholder="Custom Field value 2">
                  <small class="form-text text-muted" v-if="hasErrors.productcf_val2" ><strong style="color: red;">Enter Valid Product Classification</strong></small>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                 
                  <input type="text" class="form-control" id="productcf_val3" :class="{'is-invalid':hasErrors.productcf_val3}" v-model="product.productcf_val3" placeholder="Custom Field value 3">
                  <small class="form-text text-muted" v-if="hasErrors.productcf_val3" ><strong style="color: red;">Enter Valid Product Classification</strong></small>
                  </div>
                </div>
                 
              </div>
              <br v-if="1 === 2">
              <div class="row">
                <div class="col-sm-6" v-if="1 === 2">
                  <div class="form-group">
                    <b-form-checkbox @input="hasBarcode()" value="1" unchecked-value="0">I have product barcode number</b-form-checkbox>
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.productbarcodesymbol}" v-model="product.productbarcodesymbol" placeholder="Enter Barcode Number" :disabled="disabled == 0 ? false : true">
                    <small class="form-text text-muted" v-if="hasErrors.productbarcodesymbol" ><strong style="color: red;">{{ errorMessage.productbarcodesymbol }}</strong></small>
                  </div>
                </div> 
                <div class="col-sm-4" style="margin-top: 28px;">
                    <b-form-checkbox v-model="checkboxtk" value="true" unchecked-value="false"> Product Track Quantity </b-form-checkbox>
                </div>
              </div>
              <div class="card-footer modal_footer"><button type="submit" class="btn btn-sm btn-primary" @click.prevent="Submit()"><i class="fa fa-dot-circle-o"></i> Save</button>&nbsp;&nbsp;&nbsp;&nbsp;<button class="btn btn-sm btn-primary" @click="hide">Close</button></div>
              <Spinner v-if="loading"></Spinner>
            </b-modal> 
  <!-- </div> -->
</template>
<script>
  import Modal from '../../modal_plugins.js';
  import { VueEditor } from 'vue2-editor';
  import Spinner from '../../spinner.vue';
export default {
	components: {
      VueEditor,
      Spinner
    },
  data() {
    return {
        access_token:null,
        disabled:1,
        pluscheck:false,
        largeModal:false,
        loading:false,
        checkboxqty:false,
        checkboxtk:false,
        varientlist:[],
        pdid:'',
        pdname:'',
        rows:[],
        category: [],
        unitopt: [],
        brndopt: [],
        hsnopt: [],
        taxopt: [],
        specs: [],
        subcategory:[],
        selectedCategory: null,
        allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
        maximumSize: 500000,
        selectedSub:null,
        selectedBrand:null,
        selectedUnit:null,
    
        selectedHsn:null,
        selectedTax:null,
        product:{
          altproductid:'',
          productname:'',
          productdesc:'',
          productbarcodesymbol:'',
          productalertqty:'',
          productcf1:'',
          productcf2:'',
          productcf3:'',
          productcf_val1:'',
          productcf_val2:'',
          productcf_val3:'',
          specname:'',
          specdesc:'',
          variantname:null,
          image1:null,
          image2:null,
          image3:null,
          image4:null,
          image5:null,
          image5:null,
          imageArr:[],
          imageUrl:[],
        },
        indx:0,
        hasErrors:{
          message:false ,
          altproductid:false,
          productname:false,
          productdesc:false,
          productcode:false,
          productalert:false,
          productcf1:false,
          productcf2:false,
          productcf3:false,
          productcf_val1:false,
          productcf_val2:false,
          productcf_val3:false,
          specname:false,
          specdesc:false,
          variantname:false,
          image:false,
          selectedHsn:false,
          selectedTax:false,
          productbarcodesymbol:false,
        },
        errorMessage:{
          message:null,
          image1:null,
          image2:null,
          image3:null,
          image4:null,
          image5:null,
          image6:null,
          selectedHsn:'',
          selectedTax:'',
          productbarcodesymbol:'',
        }
      }
  },
  computed: {
    companyTaxType() {
      var companyId = localStorage.getItem('companyId') || ''
      return (this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId]) || 'IN'
    }
  },
  methods: {

    hide() {
      // method for closing modal
      // this.visible = false;
      this.largeModal = false;
    },
    addRow(){
        this.specs.push({specname:'', specdesc:''})
      },
    getvariant(val){
        if(val === 'comp'){
          if(this.vf_time === false){
            this.vf_time = true
          }
          else{
            return
          }
        }
        var _this = this
        this.$http.get('/api/variants').then(function(response){
          _this.varientlist=response.data;
        }).catch(function(error){
        })
      },

      // getproducttl(){
      //   var _this = this
      //   this.$http.get('/api/companyproducts').then(function(response){
      //      _this.totalRecords = response.data[0].totalRecords;
      //     response.data.shift()
      //     if(response.data != undefined)
      //     _this.rows = response.data;
        
      //   }).catch(function(error){
      //   })
      // },

      tax_name(opt){
        // var _this = this
        // var selectedhsnobj = this.hsnopt.filter(function(each){
        //         return each.hsn_id === _this.selectedHsn
        //     });
        // var select_tax = this.taxopt.filter(function(each){
        //         return each.tax_id === _this.selectedhsnobj[0].tax_id
        //     });
        // this.selectedTax = select_tax[0]
        var _this=this
        this.$http.get('/api/taxrates?filter[where][tax_id]='+opt.tax_id).then(function(response){
          _this.taxopt = response.data
          _this.selectedTax = response.data[0]
        }).catch(function(error){
        })
      },

      brand_name(val){
        if(val === 'comp'){
          if(this.bf_time === false){
            this.bf_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/brands').then(function(response){
          _this.brndopt=  response.data;
        })
        .catch(function(error){
        })
      },

      unit_name(val){
        if(val === 'comp'){
          if(this.uf_time === false){
            this.uf_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/unittypes').then(function(response){
          _this.unitopt=response.data;
        }).catch(function(error){
        })
      },

      // tax_name(opt){
      //   var _this=this
      //   this.$http.get('/api/taxrates?filter[where][tax_id]='+opt.tax_id).then(function(response){
      //     _this.taxopt = response.data
      //     _this.selectedTax = response.data[0]
      //   }).catch(function(error){
      //   })
      // },

      tax_name2(opt){
        var _this=this
        this.$http.get('/api/taxrates?filter[where][tax_id]='+opt).then(function(response){
          _this.taxopt = response.data
          _this.selectedTax = response.data[0]
        }).catch(function(error){
        })
      },

      hsnno(val){
        if(val === 'comp'){
          if(this.hf_time === false){
            this.hf_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/hsns').then(function(response){
          _this.hsnopt = response.data;
        }).catch(function(error){
        })
      },
      
      subcategory1(category){
        this.subcategory = [];
        this.selectedSub =null
        this.selectedSub = null
        var _this=this
        var id=category.category_id
        
        this.$http.get('/api/subcategories?filter[where][category_id]='+id).then(function (response) {
          _this.subcategory=response.data;
        })
        .catch(function (error) {
        });
      },

      subcategory2(category){
        this.subcategory = [];
        this.selectedSub =null
        this.selectedSub = null
        var _this=this
        var id = category
        this.$http.get('/api/subcategories?filter[where][category_id]='+id).then(function (response) {
          _this.subcategory=response.data;
        })
        .catch(function (error) {
        });
      },

      getCategories(val){
        if(val === 'comp'){
            if(this.cf_time === false){
              this.cf_time = true
            }
            else{
              return
            }
          }
        var _this=this
        this.$http.get('/api/categories').then(function (response){
          _this.category=response.data;
        })
        .catch(function (error) {
        });
      },

    reset(){
        var _this=this
        _this.reset_specs()
        _this.product.imageArr = []
        _this.product.imageUrl = []
        _this.product.variantname = null
        _this.product.altproductid = ''
        _this.product.productname = ''
        _this.product.productdesc = ''
        _this.product.productbarcodesymbol = ''
        _this.product.productalertqty = '' 
        _this.product.productcf1 = ''
        _this.product.productcf_val1=''
        _this.product.specname = ''
        _this.product.specdesc = ''
        _this.selectedCategory = null 
        _this.subcategory = []
        _this.selectedSubc =null
        _this.selectedBrand = null
        _this.selectedHsn = null               
        _this.selectedTax = null
        _this.taxopt = []
        _this.selectedUnit = null
        _this.hasErrors.message=false;
        _this.errorMessage.message=   null;
        _this.hasErrors.selectedHsn=false;
        _this.hasErrors.productbarcodesymbol = false
        _this.errorMessage.selectedHsn=   null;
        _this.hasErrors.selectedTax=false;
        _this.errorMessage.selectedTax=   null;
        _this.errorMessage.productbarcodesymbol = ''
        _this.hasErrors.productname=false;
        _this.errorMessage.productname=   null;
        _this.productedit=0;
        _this.producteditvalue=null;
        _this.pluscheck=false;
        _this.product.productcf2='';
        _this.product.productcf3='';
        _this.product.productcf_val2=''
        _this.product.productcf_val3=''
        _this.checkboxqty=false;
        _this.checkboxtk=false;
        _this.selectedSub=null;
        _this.image1=null;
        _this.image2=null;
        _this.image3=null;
        _this.image4=null;
        _this.image5=null;
        _this.image6=null;
        _this.productimagevalue1=null;
        _this.productimagevalue2=null;
        _this.productimagevalue3=null;
        _this.productimagevalue4=null;
        _this.productimagevalue5=null;
        _this.productimagevalue6=null;
      },

    show(params) {
      // making modal visible
      this.reset();
    //  this.getCategories('comp');
    //  this.unit_name('comp');
	   // this.brand_name('comp');
	   // this.hsnno('comp');
	   // this.getvariant('comp');
	    
      this.category = params.category
      this.unitopt = params.unitopt
      this.brndopt = params.brndopt
      this.hsnopt = params.hsnopt
	    this.varientlist = params.varientlist
      // this.taxopt = params.taxopt
     // this.visible = true
      this.largeModal = true
    },

    reset_specs(){
        // if(val === 'comp'){
        //   if(this.rsf_time === false){
        //     this.rsf_time = true
        //   }
        //   else{
        //     return
        //   }
        // }
        if(this.specs.length > 0){
          for (var i = this.specs.length-1; i >=0;  i--) {
            this.specs.splice(i,1);
          }
        }
        for (var i = 0; i < 1; i++) {
          this.specs.push({specname:'', specdesc:''})
        }
      },
    imagefun1(callback){
     var _this = this
      const image1 = document.querySelector('#image1');
      if(this.product.imageArr[0]){
     
        if(image1.files[0]!=undefined){
    
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[0])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return _this.product.imageArr[0]
        }
      }else{
        if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
      },
    imagefun2(callback){
      var _this = this
      const image2 = document.querySelector('#image2');
      if(this.product.imageArr[1]!=null){
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[1])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[1]
        }
      }else{
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }

     
      },
   imagefun3(callback){
      var _this = this
      const image3 = document.querySelector('#image3');
      if(this.product.imageArr[2]!=null){
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[2])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[2]
        }
      }else{
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
        
      },
    imagefun4(callback){
      var _this = this
      const image4 = document.querySelector('#image4');
      if(this.product.imageArr[3]!=null){
        if(image4.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[3])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[3]
        }
      }else{
        if(image4.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }

      },
    imagefun5(callback){
      var _this = this
      const image5 = document.querySelector('#image5');
      if(this.product.imageArr[4]!=null){
        if(image5.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[4])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[4]
        }
      }else{
        if(image5.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }

      },
    imagefun6(callback){
     var _this = this
      const image6 = document.querySelector('#image6');
      if(this.product.imageArr[5]!=null){
        if(image6.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[5])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[5]
        }
      }else{
        if(image6.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
    },

    Submit(){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        var _this=this

        _this.hasErrors.altproductid=false;
        _this.hasErrors.productname=false;
        _this.hasErrors.selectedHsn=false;
        _this.hasErrors.selectedTax=false;
        _this.hasErrors.productdesc=false;
        _this.hasErrors.productcode=false;
        _this.hasErrors.productalert=false;
        _this.hasErrors.productcf1=false;  
        _this.hasErrors.productcf2=false;  
        _this.hasErrors.productcf3=false; 
        _this.hasErrors.productcf_val1=false;
        _this.hasErrors.productcf_val2=false;
        _this.hasErrors.productcf_val3=false;
        _this.hasErrors.specdesc=false;
        _this.hasErrors.variantname=false;
        _this.hasErrors.productbarcodesymbol=false;
        this.hasErrors.image=false;
        this.errorMessage.image1=null;
        this.errorMessage.image2=null;
        this.errorMessage.image3=null;
        this.errorMessage.image4=null;
        this.errorMessage.image5=null;
        this.errorMessage.image6=null;
        this.errorMessage.selectedHsn=null; 
        this.errorMessage.selectedTax=null;
        this.errorMessage.productbarcodesymbol='';
        var fileInput1 = document.querySelector('#image1');
        var fileInput2 = document.querySelector('#image2');
        var fileInput3 = document.querySelector('#image3');
        var fileInput4 = document.querySelector('#image4');
        var fileInput5 = document.querySelector('#image5');
        var fileInput6 = document.querySelector('#image6');
        var submit_true='0';
        var nrex=/^[a-zA-Z0-9\s]{3,100}$/
        var brex=/^[a-zA-Z0-9\s]{3,100}[!@#$%^.,%&<>'":;/_|]{0,3}$/
        var urex=/^[0-9]{1,9}$/
        if(fileInput1.files[0]!=undefined){
          if(fileInput1.files[0].size>this.maximumSize){
            this.errorMessage.image1="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
          else if( this.allowableTypes.indexOf(fileInput1.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image1="Invalid Image Type"
            submit_true='1'
          }else{ this.errorMessage.image1=""}
        }


      if(fileInput2.files[0]!=undefined){
        if(fileInput2.files[0].size>this.maximumSize){
            this.errorMessage.image2="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
        else if( this.allowableTypes.indexOf(fileInput2.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image2="Invalid Image Type"
            submit_true='1'
          }
        else{  this.errorMessage.image2=""}
        }

      if(fileInput3.files[0]!=undefined){
        if(fileInput3.files[0].size>this.maximumSize){
            this.errorMessage.image3="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
        else if( this.allowableTypes.indexOf(fileInput3.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image3="Invalid Image Type"
            submit_true='1'
          }
        else{ this.errorMessage.image3=""}
        }

      if(fileInput4.files[0]!=undefined){
        if(fileInput4.files[0].size>this.maximumSize){
            this.errorMessage.image4="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
        else if( this.allowableTypes.indexOf(fileInput4.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image4="Invalid Image Type"
            submit_true='1'
          }
          else{  this.errorMessage.image4=""}
        }

      if(fileInput5.files[0]!=undefined){
        if(fileInput5.files[0].size>this.maximumSize){
            this.errorMessage.image5="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
        else if( this.allowableTypes.indexOf(fileInput5.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image5="Invalid Image Type"
            submit_true='1'
          }
        else{ this.errorMessage.image5=""}
        }

        if(fileInput6.files[0]!=undefined){
          if(fileInput6.files[0].size>this.maximumSize){
              this.errorMessage.image6="Image Size Cannot Be Greater Than 500kb"
              submit_true='1'
          }else if( this.allowableTypes.indexOf(fileInput6.files[0].type.toLowerCase())=== -1){
              this.errorMessage.image6="Invalid Image Type"
              submit_true='1'
          }else{
            this.errorMessage.image6=""
          }
        }

        if(this.disabled === 0){
          /*var barcode_present = false

          if(this.product.productbarcodesymbol != ''){
            this.$http.get('/api/companyproducts/findOne?filter[where][product_barcode_symbol]='+this.product.productbarcodesymbol).then(function(response){
              barcode_present = true
              _this.hasErrors.productbarcodesymbol=true;
              _this.errorMessage.productbarcodesymbol="This barcode already used"
            })
            .catch(function(error){
              barcode_present = false
            })
          }*/

          if(this.product.productbarcodesymbol == ''){
            this.hasErrors.productbarcodesymbol=true;
            this.errorMessage.productbarcodesymbol="Required"
            submit_true='1'
          }else if(this.product.productbarcodesymbol.length > 20){
            this.hasErrors.productbarcodesymbol=true;
            this.errorMessage.productbarcodesymbol="Cannot be greater than 20 characters"
            submit_true='1'
          }else if(this.product.productbarcodesymbol.length < 2){
            this.hasErrors.productbarcodesymbol=true;
            this.errorMessage.productbarcodesymbol="Cannot be less than 1 character"
            submit_true='1'
          }
        }

        if(this.product.productname.length > 100){
          this.hasErrors.productname=true;
          this.errorMessage.productname=" Enter maximum 100 characters"
          submit_true='1'
        }

        if(this.product.productname=='')
        {
           this.hasErrors.productname=true;
           this.errorMessage.productname="Required"
           submit_true='1'
        }else{  this.errorMessage.productname=''}

        // if(this.selectedHsn==undefined){
        //    this.errorMessage.selectedHsn="Required" 
        //  submit_true='1'
        // }else{  this.errorMessage.selectedHsn='' }

        // if(this.selectedTax==undefined){
        //    this.errorMessage.selectedTax="Required" 
        //   submit_true='1'
        // }else{this.errorMessage.selectedTax='' }

        if (submit_true=='0'){

          Promise.all([this.imagefun1(),this.imagefun2(),this.imagefun3(),this.imagefun4(),this.imagefun5(),this.imagefun6()]).then((user)=>{
            _this.productval(_this,user); 
          });
        }
        else{
          _this.loading=false
        }
      },

      productval(_this,user){
        this.loading=true
        var product = {}
        var tempArr = []
        for(var i= 0;i<user.length;i++){
          if(user[i]!= null)
          {
            tempArr.push(user[i])
          }
        }
        if(tempArr.length==0){
          tempArr=null
        }
        if(this.selectedCategory!=undefined){
          product.category_id=this.selectedCategory.category_id
        }
        if(this.selectedSub!=undefined){
          product.sub_category_id=this.selectedSub.sub_category_id
        }
        if(this.selectedUnit!=undefined){
          product.unit_id=this.selectedUnit.unit_id
        }
        if(this.selectedBrand!=undefined){
          product.brand_id=this.selectedBrand.brand_id
        }
        if(this.selectedHsn!=undefined){
          product.hsn_id=this.selectedHsn.hsn_id
        }
        if(this.selectedTax!=undefined){
          product.tax_gst_id=this.selectedTax.tax_id
        }
        if(this.product.variantname!=undefined){
          product.variant_id=this.product.variantname.variant_id
        }
        product.alt_product_id= this.product.altproductid,
        product.product_name= this.product.productname,
        product.product_desc= this.product.productdesc,
        product.product_barcode_symbol= this.product.productbarcodesymbol,
        product.product_alert_qty= this.product.productalertqty,
        product.product_track_req= this.checkboxqty,
        product.product_tax_method= this.checkboxtk,
        product.img=tempArr,
        product.specification='',
        product.specRow = this.specs
        product.product_cf1= this.product.productcf1,
        product.product_cf2=this.product.productcf2,
        product.product_cf3=this.product.productcf3,
        product.product_cf1_value=this.product.productcf_val1,
        product.product_cf2_value=this.product.productcf_val2,
        product.product_cf3_value=this.product.productcf_val3,
        product.disabled=this.disabled

       
        if(this.productedit==0){
          this.$http.post('/api/companyproducts',product) .then(function (response) {
            _this.reset()
            if(response.status===200){
              _this.loading=false
              _this.largeModal=false;
              // _this.hasErrors.message=true;
              // _this.errorMessage.message='Product Added Successfully';
              alert('Product Added Successfully');
              _this.$store.commit('set_productmodal', response.data)
              // _this.getproducttl();
              // setTimeout(function(){_this.hasErrors.message=false;}, 4000);
            }else{
              if(user!=null){
                return _this.$http.delete('/api/containers/pics/files/'+user)
              }
            }
          })
          .catch(function (error) {
            _this.loading=false
            if(user!=null){
              return _this.$http.delete('/api/containers/pics/files/'+user)
            }
          });
        }
        // else{
         
        //   this.$http.post('/api/companyproducts/update?where[product_id]='+this.producteditvalue,product).then(function (response){
        //     _this.reset()
        //     if(response.status===200){
        //       _this.loading=false
        //       _this.largeModal=false;
        //       _this.hasErrors.message=true;
        //       _this.errorMessage.message='Product Updated Successfully';
        //       _this.getproducttl();
        //       setTimeout(function(){_this.hasErrors.message=false;}, 4000);
        //     }else{
        //       if(user!=null){
        //          return _this.$http.delete('/api/containers/pics/files/'+user)
        //       }
        //     }               
        //   })
        //   .catch(function (error) {
        //     _this.loading=false
        //     if(user!=null){
        //       return _this.$http.delete('/api/containers/pics/files/'+user)
        //     }
        //   });
        // }
      },

      reset(){
        var _this=this
        _this.reset_specs()
       
        _this.product.imageArr = []
        _this.product.imageUrl = []
        _this.product.variantname = null
        _this.product.altproductid = ''
        _this.product.productname = ''
        _this.product.productdesc = ''
        _this.product.productbarcodesymbol = ''
        _this.product.productalertqty = '' 
        _this.product.productcf1 = ''
        _this.product.productcf_val1=''
        _this.product.specname = ''
        _this.product.specdesc = ''
        _this.selectedCategory = null 
        _this.subcategory = []
        _this.selectedSubc =null
        _this.selectedBrand = null
        _this.selectedHsn = null               
        _this.selectedTax = null
        _this.taxopt = []
        _this.selectedUnit = null
        _this.hasErrors.message=false;
        _this.errorMessage.message=   null;
        _this.hasErrors.selectedHsn=false;
        _this.hasErrors.productbarcodesymbol = false
        _this.errorMessage.selectedHsn=   null;
        _this.hasErrors.selectedTax=false;
        _this.errorMessage.selectedTax=   null;
        _this.errorMessage.productbarcodesymbol = ''
        _this.hasErrors.productname=false;
        _this.errorMessage.productname=   null;
        _this.productedit=0;
        _this.producteditvalue=null;
        _this.pluscheck=false;
        _this.product.productcf2='';
        _this.product.productcf3='';
        _this.product.productcf_val2=''
        _this.product.productcf_val3=''
        _this.checkboxqty=false;
        _this.checkboxtk=false;
        _this.selectedSub=null;
        _this.image1=null;
        _this.image2=null;
        _this.image3=null;
        _this.image4=null;
        _this.image5=null;
        _this.image6=null;
        _this.productimagevalue1=null;
        _this.productimagevalue2=null;
        _this.productimagevalue3=null;
        _this.productimagevalue4=null;
        _this.productimagevalue5=null;
        _this.productimagevalue6=null;
      },
 },

  beforeMount() {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    Modal.EventBus.$on('show', (params) => {
      this.show(params)
    })
  }
}
</script>

<style scoped>
/*.modal-wrapper {
  position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    outline: 0;
}*/
</style>


// WEBPACK FOOTER //
// src/views/setting/AddProductModal.vue